<div [ngStyle]="{'background-color': color}" class="toastr-class">
    <span *ngIf="isIconShown" class="icon-success"><img [src]=iconSource alt="toast-icon"/></span> 
    <span id="toast" class="message">{{message | customTranslation: translationData }} </span>
 </div>
 